module.exports = __webpack_public_path__ + "img/icon-esim-detail-coverage-arrow-dark.c977060.svg";